module.exports = __webpack_public_path__ + "media/assets/close_thin-a8453e773ae706ec59fab79bd2e474b4.svg";